import styled from 'styled-components';

export const StyledChatConversations = styled.div`
  .status.unread {
    background-color: ${({ theme }) => theme.messageNotifications};
  }

  .status.read {
    background-color: ${({ theme }) => theme.colorBorder};
    color: ${({ theme }) => theme.textColor};
  }

  .mobile-list-card-footer-item {
    .ant-btn.ant-btn-primary {
      justify-content: center;
    }
  }

  .is-unread {
    font-weight: 700;
  }
`;
